module.exports = __webpack_public_path__ + "static/media/Niubiz.620543e3.png";